export const AUTH_TOKEN = "ams-auth";
export const REFRESH_TOKEN = "ams_refresh_token";
